import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { IAction, IAppState } from '../../models/action/core';
import Translator from '../../core/i18n';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import Moment from 'moment';
import * as Actions from '../../store/actions/messages';
import { IConversation } from '../../models/pages/messages';
import ConversationListItem from './conversationListItem';
import queryString from 'querystring';
import ContentLoader from 'react-content-loader';
import ReactGA from 'react-ga4';

const T = Translator.create();
const _logger = Log.create('Message Page conversationList');
let _common: Common;
const AUTO_UPDATE_INTERVAL_SECONDS: number = 30;
let isRedirectToMessage: boolean = true;

export class CConversationList extends Component<any, any> {
    timerForConversationListUpdate: number = 0;
    keepUpdatingConversations: boolean = true;
    searchInput: HTMLInputElement | null = null;


    public state = {
        tabIndex: 0,
        showSearch: false,
        query: '',
        showMoreGroupCount: 3,
        showMoreContactCount: 3,
        showMoreStartedCount: 3,
        showList: false,
        isGroupMessagesLoading: false,
        isPersonalMessagesLoading: false
    };

    constructor(props: any) {
        super(props);
        _common = new Common();
        if (T.i18next.language === 'tr') {
            Moment.locale('tr');
        }
        if (T.i18next.language === 'en') {
            Moment.locale('en');
        }
    }

    public componentDidMount() {
        isRedirectToMessage = true;
        this.getGroupConversations();
        this.getContactConversations();
        this.timerForConversationListUpdate = window.setInterval(this.getContactConversations.bind(this, 'getMessageLoadingBox'), AUTO_UPDATE_INTERVAL_SECONDS * 1000);
    }

    componentDidUpdate(prevProps: any) {
        const messageItemToRefresh = this.props.currentContextType === 0 ?
            this.props.userConversations.filter((item: any) => item.recipientUserId === this.props.currentContextId) :
            this.props.groupConversations.filter((item: any) => item.recipientUserId === this.props.currentContextId);
        if (this.props.originMessageId === '-1' && messageItemToRefresh.length > 0) {
            this.scrollToItem(messageItemToRefresh[0].originMessageId);
        }
        if (this.state.showSearch && this.searchInput) {
            this.searchInput.focus();
        }
    }

    public componentWillUnmount() {
        window.clearInterval(this.timerForConversationListUpdate);
    }

    getContactConversations = (spinnerId?: string) => {
        if (this.keepUpdatingConversations) {
            this.props.dispatch(
                Actions.getConversationListAction({
                    skip: 0,
                    take: this.state.showMoreContactCount,
                    keyword: '',
                    spinnerId: spinnerId ?? 'getContactConversationsAction',
                    spinnerType: 'get',
                    isGroup: false,
                    callback: this.callback
                })
            );
        }
    };

    getGroupConversations = (spinnerId?: string) => {
        if (this.keepUpdatingConversations) {
            this.props.dispatch(
                Actions.getConversationListAction({
                    skip: 0,
                    take: this.state.showMoreGroupCount,
                    keyword: '',
                    spinnerId: spinnerId ?? 'getGroupConversationsAction',
                    spinnerType: 'get',
                    isGroup: true,
                    callback:this.handleMessagesLoadCompletion
                }

            )

            );
        }
    };

    handleMessagesLoadCompletion = () => {
        this.setState({ isGroupMessagesLoading: false });
    }

    callback = () => {
        if (isRedirectToMessage) {
            this.handleSearchQueryIfExists();
        }
        this.setState({ isPersonalMessagesLoading: false });
        isRedirectToMessage = false;
    }

    callbackConversations = (keyword?: string) => {
        this.props.dispatch(
            Actions.getConversationListAction({
                skip: 0,
                take: this.state.showMoreGroupCount,
                keyword: keyword ?? '',
                spinnerId: 'getMessageLoadingBox',
                spinnerType: 'get',
                isGroup: true
            })
        );
    };

    public handleSearchQueryIfExists() {
        if (isRedirectToMessage) {
            const search = window.location.search;
            const params = queryString.parse(search.replace('?', ''));
            const messageId = params.messageId ? String(params.messageId) : null;
            if (messageId) {
                const itemIndex = this.props.userConversations.findIndex((item: any) => item.originMessageId === messageId);
                if (itemIndex) {
                    this.scrollToItem(messageId);
                    return true;
                }
                return false;
            }
            return false;
        }
    }

    public scrollToItem(messageId: string) {
        const element: HTMLElement | null = document.getElementById(messageId);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
            // after scroll animation click on message to show
            setTimeout(() => {
                element.click();
            }, 1000);
        }
    }

    showAll = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_ALL_MESSAGES_CLICKED',
            label: 'G_ALL_MESSAGES_CLICKED',
            nonInteraction: true,
        });
        this.setState((prevState: any) => ({
            tabIndex: 0,
            showSearch: prevState.showSearch,
            query: prevState.query
        }));
    };

    showGroups = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_GROUP_MESSAGES_CLICKED',
            label: 'G_GROUP_MESSAGES_CLICKED',
            nonInteraction: true,
        });
        this.setState((prevState: any) => ({
            tabIndex: 1,
            showSearch: prevState.showSearch,
            query: prevState.query
        }));
    };

    showNonGroups = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_NON_GROUPS_MESSAGES_CLICKED',
            label: 'G_NON_GROUPS_MESSAGES_CLICKED',
            nonInteraction: true,
        });
        this.setState((prevState: any) => ({
            tabIndex: 2,
            showSearch: prevState.showSearch,
            query: prevState.query
        }));
    };

    updateQuery = (query: string) => {
        this.setState((prevState: any) => ({ tabIndex: prevState.tabIndex, showSearch: true, query }));
    };

    showSearch = () => {
        // disable auto-update feature
        this.keepUpdatingConversations = false;

        this.setState((prevState: any) => ({
            tabIndex: prevState.tabIndex,
            showSearch: true,
            query: prevState.query
        }));
    };

    hideSearch = () => {
        // enable auto-update feature
        this.keepUpdatingConversations = true;

        this.setState((prevState: any) => ({
            tabIndex: prevState.tabIndex,
            showSearch: false,
            query: ''
        }));
        this.props.dispatch(
            Actions.getConversationListAction({
                skip: 0,
                take: this.state.showMoreContactCount,
                keyword: '',
                spinnerId: 'getMessageLoadingBox',
                spinnerType: 'get',
                isGroup: false,
                callback: this.callbackConversations
            })
        );
    };

    onSearch = (e: any) => {
        if (e.key === 'Enter') {
            this.props.dispatch(
                Actions.getConversationListAction({
                    skip: 0,
                    take: this.state.showMoreContactCount,
                    keyword: this.state.query,
                    spinnerId: 'getMessageLoadingBox',
                    spinnerType: 'get',
                    isGroup: false,
                    callback: this.callbackConversations(this.state.query)
                })
            );
        }
    };

    onSearchTextChange = (event: any) => {
        this.updateQuery(event.target.value);
    };


    loading(start: number, length: number) {
        const loadingSpaces = 105;
        const rows = [];
        for (let index = start; index < length + start; index++) {
            rows.push(
                <>
                    <rect x="16" y={24 + (loadingSpaces * index)} rx="3" ry="3" width="45" height="25" />
                    <rect x="78" y={24 + (loadingSpaces * index)} rx="3" ry="3" width="45%" height="10" />
                    <rect x="78" y={44 + (loadingSpaces * index)} rx="3" ry="3" width="35%" height="8" />
                    <rect x="78" y={87 + (loadingSpaces * index)} rx="3" ry="3" width="50%" height="7" />
                    <rect x="78" y={60 + (loadingSpaces * index)} rx="3" ry="3" width="70.4%" height="7" />
                    <rect x="78" y={74 + (loadingSpaces * index)} rx="3" ry="3" width="70.4%" height="7" />
                    <rect x="78%" y={24 + (loadingSpaces * index)} rx="3" ry="3" width="17%" height="10" />

                    <rect x="78" y={110 + (loadingSpaces * index)} rx="1" ry="1" width="70.4%" height="1" />
                </>
            );
        }

        return rows;
    }

    public showMoreOnGroupClick = () => {
        this.setState({ isGroupMessagesLoading: true });
        this.setState((prevState: any) => ({ showMoreGroupCount: prevState.showMoreGroupCount + 3 }), () => {
            this.getGroupConversations();
        });
    };

    public showMoreOnContactClick = () => {
        this.setState({ isPersonalMessagesLoading: true });
        this.setState((prevState: any) => ({ showMoreContactCount: prevState.showMoreContactCount + 3 }), () => {
            this.getContactConversations();
        });
    };
    showList = () => {

        const item = document.getElementById('currentChatListPanel');
        const itemContact = document.getElementById('contactListPanel');

        if (item && itemContact) {
                    item.style.display = 'none';
                    itemContact.style.display = 'block';
        }

    };

    renderGroupConversations = () => {
        const conversations = this.state.showMoreStartedCount ? this.props.groupConversations.slice(0, this.state.showMoreGroupCount) : this.props.groupConversations;

        return (

            <React.Fragment>
                {
                    conversations.map((item: IConversation) => (
                        <ConversationListItem
                            {...item}
                            id={item.originMessageId}
                            key={item.originMessageId}
                            thisUserId={this.props.userId}
                            userPreferences={this.props.userPreferences}
                            dispatch={this.props.dispatch}
                            triggerMessageModalClosed={this.props.triggerMessageModalClosed}
                            messageModelClosed={this.props.messageModelClosed}
                            images={item.images[0]}
                        />
                    ))
                }
                {this.renderShowMoreButtons(this.props.groupConversations, this.state.showMoreGroupCount, true)}
                </React.Fragment>

        )
    }

    renderUserConversations = (conversationList: any) => {
        const conversations = this.state.showMoreStartedCount ? conversationList.slice(0, this.state.showMoreContactCount) : conversationList;

        return (
            <React.Fragment>
                {
                    conversations.map((item: any) => (
                        <ConversationListItem
                            {...item}
                            id={item.originMessageId}
                            key={item.originMessageId}
                            thisUserId={this.props.userId}
                            userPreferences={this.props.userPreferences}
                            dispatch={this.props.dispatch}
                            triggerMessageModalClosed={this.props.triggerMessageModalClosed}
                            messageModelClosed={this.props.messageModelClosed}
                            images={item.images[0]}
                        />
                    ))
                }
                {this.renderShowMoreButtons(this.props.userConversations, this.state.showMoreContactCount, false)}
            </React.Fragment>

        )
    }

    renderShowMoreButtons = (conversationList: any, listCount: number, isGroup: boolean) => {
        return (
            (this.state.showMoreStartedCount && ((conversationList.totalCount ?? 0) - listCount > 0)) ? (
                <button style={{ border: 'none', background: 'none' }} onClick={ isGroup ? this.showMoreOnGroupClick : this.showMoreOnContactClick} >
                    <div className="modal-body">
                        <div>
                            <label style={{ cursor: 'pointer' }} tabIndex={0}>{T.t('r_gen_show_more')}</label>
                        </div>
                    </div>
                </button>
            ) : ''
        )
    }


    public render() {
        return (
            <div className="main-sidebar messages_list_sidebar">
                <div>
                    <div data-active="active" className="mt-0 position-relative"  >
                        <div className="mobile-message-search d-flex justify-content-between align-items-center" style={{padding:'.5em'}}>
                            <span style={{ fontSize: '1.25em', fontWeight: '500' }} tabIndex={0}>{T.t('r_home_index_box_message')}</span>
                            <div className="mobile-message-input-search options d-inline-flex align-items-center">

                                <button data-toggle="collapse" style={{ border: 'none', background: 'none' }} onClick={this.showSearch} tabIndex={0}>
                                    <i className="material-icons">search</i>
                                </button>
                                <button className="display_sm" data-toggle="collapse" style={{ border: 'none', background: 'none' }} onClick={this.showList} tabIndex={0}>
                                    <i className="material-icons">add</i>
                                </button>
                            </div>
                        </div>
                        <div id="searchConversations" className={'mobile-message-input-search  search' + (this.state.showSearch ? ' collapse show' : ' collapse')}>
                            <div className="input-group">
                                <div data-toggle="collapse" className="input-group-prepend" onClick={this.hideSearch}>
                                    <div className="input-group-text">
                                        <i className="material-icons">arrow_back</i>
                                    </div>
                                </div>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="inlineFormInputGroup"
                                    placeholder={T.t('r_gen_search')}
                                    onKeyDown={this.onSearch}
                                    onChange={this.onSearchTextChange}
                                    ref={e => (this.searchInput = e)}
                                    value={this.state.query}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="announcementTabs" style={{ height: '82%' }}>
                    <ul className="nav nav-tabs border-0" style={{paddingInlineStart: '0px'}} id="conversationTabs" role="tablist">
                        <li className="nav-item">
                            <a className={'nav-link ' + (this.state.tabIndex === 0 ? 'active show' : '')} onClick={this.showAll}>
                                {T.t('r_gen_all')}
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className={'nav-link ' + (this.state.tabIndex === 1 ? 'active show' : '')} onClick={this.showGroups}>
                                {T.t('r_gen_group')}
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className={'nav-link ' + (this.state.tabIndex === 2 ? 'active show' : '')} onMouseDown={this.showNonGroups} lang='tr'>
                                {T.t('r_gen_personal')}
                            </a>
                        </li>
                    </ul>
                    <div className="tab-content" style={{ height: '100%', position: 'relative' }}>
                        <div
                            className={'tab-pane fade ' + (this.state.tabIndex === 2 ? 'hidden' : ' show active')}
                            id="home"
                            role="tabpanel"
                            aria-labelledby="home-tab"
                            style={{ height: this.state.tabIndex === 0 ? '' : '100%' }}
                        >
                            <label className="col-label" tabIndex={0}>{T.t('r_my_group_messages')}</label>

                            <div id="getGroupConversationsAction_Content" className="single-messages">
                                {this.props.groupConversations && this.props.groupConversations.length > 0 ? (

                                    <>
                                        {
                                        this.renderGroupConversations()
                                        }
                                        {
                                            this.state.isGroupMessagesLoading ? (
                                            <div  className="d-flex justify-content-center">
                                                <div style={{width:25,height:25}} className="spinner-border text-primary" role="status">

                                                </div>
                                            </div>
                                            ) : ''
                                        }
                                    </>
                                ) : (
                                    <div className="ml-3 small" tabIndex={0}>{T.t('r_no_group_message')}</div>
                                )}
                            </div>
                        </div>
                        <div
                            className={'tab-pane fade ' + (this.state.tabIndex === 1 ? 'hidden' : ' show active')}
                            id="home"
                            role="tabpanel"
                            aria-labelledby="home-tab"
                            style={{ height: this.state.tabIndex === 0 ? '' : '100%' }}
                        >
                            <label className="col-label" lang="tr" tabIndex={0}>{T.t('r_my_personal_messages')}</label>

                            <div id="getContactConversationsAction_Content" className="single-messages">
                                {this.props.userConversations && this.props.userConversations.length > 0 ? (
                                    <>
                                        {this.renderUserConversations(this.props.userConversations)}
                                        {
                                            this.state.isPersonalMessagesLoading ? (
                                            <div  className="d-flex justify-content-center">
                                                <div style={{width:25,height:25}} className="spinner-border text-primary" role="status">

                                                </div>
                                            </div>
                                            ) : ''
                                        }
                                    </>
                                )
                                    : (
                                        <div className="ml-3 small">{T.t('r_no_personal_message')}</div>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: any): any => {
    if (!state) {
        return ownProps;
    }

    const newProps: any = Object.assign({}, ownProps, {
        groupConversations: state.message.groupConversations,
        userConversations: state.message.userConversations,
        userPreferences: state.profile.userPreferences.preferences,
        currentContextId: state.message.currentContextId,
        currentContextType: state.message.currentContextType,
        originMessageId: state.message.originMessageId,
        userId: state.login.identitiy.userId
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.message.groupConversations === prev.message.groupConversations &&
        next.message.userConversations === prev.message.userConversations &&
        next.message.currentContextId === prev.message.currentContextId &&
        next.message.currentContextType === prev.message.currentContextType &&
        next.message.originMessageId === prev.message.originMessageId;
    return ret;
};

const ConversationList = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CConversationList);

export default ConversationList;